import { HYDRA_SAVE_ODSP } from 'constants/hydraTests';
import {
  EVENT_ON_DEMAND,
  RECEIVE_BRAND_LIST_FAILURE,
  RECEIVE_BRAND_LIST_SUCCESS,
  RECEIVE_ON_DEMAND_SIZING_PREDICTION_FAILURE,
  RECEIVE_ON_DEMAND_SIZING_PREDICTION_SUCCESS,
  RECEIVE_SUPPORTED_BRANDS_FAILURE,
  RECEIVE_SUPPORTED_BRANDS_SUCCESS,
  REQUEST_BRAND_LIST,
  REQUEST_ON_DEMAND_SIZING_PREDICTION,
  REQUEST_SUPPORTED_BRANDS,
  SAVE_ODSP_DATA,
  SET_MODAL_VIEW,
  UPDATE_BRAND,
  UPDATE_PRODUCT_CATEGORY,
  UPDATE_PRODUCT_SIZE
} from 'constants/reduxActions';

import { trackError } from 'helpers/ErrorUtils';
import { trackEvent } from 'helpers/analytics';
import { fetchErrorMiddleware } from 'middleware/fetchErrorMiddleware';
import { brandList } from 'apis/cloudcatalog';
import { sizingPredictionOnDemand, supportedBrands } from 'apis/opal';
import { getAssignmentGroup } from 'actions/ab';

export function setModalView(modalView) {
  return {
    type: SET_MODAL_VIEW,
    modalView
  };
}

export function saveOdsp(data) {
  return {
    type: SAVE_ODSP_DATA,
    data
  };
}

export function updateProductCategory(productCategory) {
  return {
    type: UPDATE_PRODUCT_CATEGORY,
    productCategory
  };
}

export function updateProductSize(productSize) {
  return {
    type: UPDATE_PRODUCT_SIZE,
    productSize
  };
}

export function updateBrand({ brandId, brandName, autoCompleteValue, isBrandInvalid }) {
  return {
    type: UPDATE_BRAND,
    brandId,
    brandName,
    autoCompleteValue,
    isBrandInvalid
  };
}

function requestSizingPredictionOnDemand() {
  return {
    type: REQUEST_ON_DEMAND_SIZING_PREDICTION
  };
}

function receiveSizingPredictionOnDemandSuccess(predictedSize, uncertainty) {
  return {
    type: RECEIVE_ON_DEMAND_SIZING_PREDICTION_SUCCESS,
    predictedSize,
    uncertainty
  };
}

function receiveSizingPredictionOnDemandFailure() {
  return {
    type: RECEIVE_ON_DEMAND_SIZING_PREDICTION_FAILURE
  };
}

export function fetchSizingPredictionOnDemand(reqData) {
  return function (dispatch, getState) {
    dispatch(requestSizingPredictionOnDemand());
    const state = getState();
    const { environmentConfig: { api: { opal: opalInfo } } } = state;

    const hydraSop = getAssignmentGroup(HYDRA_SAVE_ODSP, state);
    reqData.hydraSop = hydraSop;

    return sizingPredictionOnDemand(opalInfo, reqData)
      .then(fetchErrorMiddleware)
      .then(({ error: apiError, prediction, uncertainty }) => {
        if (prediction) {
          dispatch(receiveSizingPredictionOnDemandSuccess(prediction, uncertainty));
        } else if (apiError || hydraSop) {
          let error = apiError;
          if (hydraSop && !error) {
            error = 'UnableToPredict';
          }
          dispatch(receiveSizingPredictionOnDemandFailure(error));
          trackEvent('TE_PDP_ONDEMAND_SIZING', `${reqData.productId}:NoResponse:${error}`);
        }
      })
      .catch(e => {
        trackError('NON-FATAL', 'Could not load on-demand sizing prediction.', e);
      });
  };
}

function requestSupportedBrands() {
  return {
    type: REQUEST_SUPPORTED_BRANDS
  };
}

function receiveSupportedBrandsSuccess(supportedBrands) {
  return {
    type: RECEIVE_SUPPORTED_BRANDS_SUCCESS,
    supportedBrands
  };
}

function receiveSupportedBrandsFailure() {
  return {
    type: RECEIVE_SUPPORTED_BRANDS_FAILURE
  };
}

export function fetchSupportedBrands(gender) {
  return function (dispatch, getState) {
    dispatch(requestSupportedBrands());
    const state = getState();
    const { environmentConfig: { api: { opal: opalInfo } } } = state;
    return supportedBrands(opalInfo, gender)
      .then(fetchErrorMiddleware)
      .then(res => {
        if (res.supportedBrands) {
          dispatch(receiveSupportedBrandsSuccess(res.supportedBrands));
        } else {
          dispatch(receiveSupportedBrandsFailure());
        }
      })
      .catch(e => {
        trackError('NON-FATAL', 'Could not load supported brands for sizing prediction.', e);
      });
  };
}

function requestBrandList() {
  return {
    type: REQUEST_BRAND_LIST
  };
}

function receiveBrandListSuccess(brandList) {
  return {
    type: RECEIVE_BRAND_LIST_SUCCESS,
    brandList
  };
}

function receiveBrandListFailure() {
  return {
    type: RECEIVE_BRAND_LIST_FAILURE
  };
}

export function fireOnDemandEvent(event, value) {
  return {
    type: EVENT_ON_DEMAND,
    event,
    value
  };
}

export function fetchBrandList() {
  return function (dispatch, getState) {
    dispatch(requestBrandList());
    const state = getState();
    const { environmentConfig: { api: { cloudcatalog } } } = state;
    return brandList(cloudcatalog)
      .then(fetchErrorMiddleware)
      .then(res => {
        if (Array.isArray(res)) {
          dispatch(receiveBrandListSuccess(res));
        } else {
          dispatch(receiveBrandListFailure());
        }
      })
      .catch(e => {
        trackError('NON-FATAL', 'Could not load the brand list.', e);
      });
  };
}
